<!--<h1>人工客服</h1>-->
<template>
  <div class="customerService">
    <h1>人工客服</h1>
  </div>
</template>

<script>
  import limitMoreClick from "../../utils/limitMoreClick";

  export default {
    name: "customerService",
    components: {},
    data() {
      return {};
    },
    mounted() {
    },
    methods: {}
  };
</script>
<style lang="less" scoped>
  .customerService {
    height: 100%;
  }
</style>

